import { render } from "./schoolSafeVideoManager.vue?vue&type=template&id=30665dec&scoped=true"
import script from "./schoolSafeVideoManager.vue?vue&type=script&lang=js"
export * from "./schoolSafeVideoManager.vue?vue&type=script&lang=js"

import "./schoolSafeVideoManager.vue?vue&type=style&index=0&id=30665dec&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30665dec"]])

export default __exports__